import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/Layouts/Card';
import { Stack, DataTable, Table, TableHead, TableRow, TableHeader, TableBody, TableCell, Checkbox } from "@carbon/react";
import { DataTable as ListChecked, View } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import InformationContainer from "../../../components/Basics/Information.container";
import routes from '../../../config/settings/routes';
import { Link } from 'react-router-dom';
import CarbonTableComponent from "../../../components/Basics/Table.container";
import { spacing05 } from "@carbon/themes";
import { onGetHdopThunk, onGetFatigueThunk, onGetChecksThunk, onGetFrentesThunk } from './Recomendations.actions';
import LoadingContent from "../../../components/Animations/LoadingContent";

/**
 * The recomendation's container.
 */
const RecomendationsContainer = () => {
    const [tableRows, setTableRows] = useState([
        { id: 'row-1', name: 'TBFJ46', status: "Bulldozer Caterpillar", example: 4.7 },
        { id: 'row-2', name: 'TPVB96', status: "Bus Scania", example: 3.0 },
        { id: 'row-3', name: 'RYWB34', status: "", example: 2.7 },
        { id: 'row-4', name: 'THWC32', status: "Minibus Mercedes", example: 10.0 },
        { id: 'row-5', name: 'SZBX32', status: "Camión tolva Volvo", example: 10.0 },
        { id: 'row-6', name: 'TRAO-417', status: "Bulldozer Caterpillar", example: 10.0 },
        { id: 'row-7', name: 'TBGJ10', status: "Camión tolva Volvo", example: 10.0 },
        { id: 'row-8', name: 'TKXD69', status: "Camión tolva Volvo", example: 10.0 },
    ]);

    const [tableRows_2, setTableRows_2] = useState([
        { id: 'row-1', name: '865326068612046', status: "TPYZ25", example: 'Camioneta' },
        { id: 'row-2', name: '865326068599433', status: "TPSF38", example: 'Camioneta' },
        { id: 'row-3', name: '865326062158657', status: "TCRX90", example: 'Bus' },
        { id: 'row-4', name: '865326062170108', status: "RXLY28", example: 'Camion Tolva' },
        { id: 'row-5', name: '865326068603870', status: "TFLS23", example: 'Minibus' },
        { id: 'row-6', name: '865326062153674', status: "SWJZ82", example: 'Camion Tolva' },
    ]);

    const [isChecked, setIsChecked] = useState(false);
    const [isChecked_2, setIsChecked_2] = useState(false);
    const [isChecked_3, setIsChecked_3] = useState(false);
    const [isChecked_4, setIsChecked_4] = useState(false);
    const [isChecked_5, setIsChecked_5] = useState(false);
    const [isChecked_6, setIsChecked_6] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        // Llama a la acción para obtener los datos HDOP
        dispatch(onGetHdopThunk());
        dispatch(onGetFatigueThunk());
        dispatch(onGetChecksThunk());
        dispatch(onGetFrentesThunk());
    }, [dispatch]);

    const { loading_hdop, hdop, loading_fatigue, fatigue, loading_checks, checks, loading_frentes, frentes } = useSelector(state => state.user);

    const rows = frentes

    const headers = [
        {
            key: 'name',
            header: 'Frente',
        },
        {
            key: 'status',
            header: 'Fecha de inicio',
        },
    ];

    // Actualizar `tableRows` con los datos de `hdop` cuando cambien
    useEffect(() => {
        if (hdop && hdop.length > 0) {
            const updatedTableRows = hdop.map((item, index) => ({
                id: `row-${index + 1}`,
                name: item.primary_name,
                status: item.type_mode,
                example: item.p80_hdop,
            }));
            setTableRows(updatedTableRows);
        }
    }, [hdop]);

    // Actualizar `tableRows_2` con los datos de `fatigue` cuando cambien
    useEffect(() => {
        if (fatigue && fatigue.length > 0) {
            const updatedTableRows_2 = fatigue.map((item, index) => ({
                id: `row-${index + 1}`,
                name: item.device_id,
                status: item.patente,
                example: item.tipo,
            }));
            setTableRows_2(updatedTableRows_2);
        }
    }, [fatigue]);

    // Actualizar `tableRows_2` con los datos de `fatigue` cuando cambien
    useEffect(() => {
        if (checks && checks.length > 0) {
            setIsChecked(String(checks[0].check_frentes).toLowerCase() === "true");
            setIsChecked_2(String(checks[0].check_hdop).toLowerCase() === "true");
            setIsChecked_6(String(checks[0].check_fatiga).toLowerCase() === "true");
            setIsChecked_3(String(checks[0].check_conexion).toLowerCase() === "true");
            setIsChecked_4(String(checks[0].check_vigencia_licencias).toLowerCase() === "true");
            setIsChecked_5(String(checks[0].check_nuevas_licencias).toLowerCase() === "true");
        }
    }, [checks]);

    // Manejar cambios en los checkboxes
    const handleCheckboxChange = (setter, value, key) => {
        setter(value);

        // Crear el objeto de parámetros actualizado
        const params = {
            check_frentes: isChecked,
            check_hdop: isChecked_2,
            check_fatiga: isChecked_6,
            check_conexion: isChecked_3,
            check_vigencia_licencias: isChecked_4,
            check_nuevas_licencias: isChecked_5,
        };

        // Asegurarte de incluir el valor actualizado
        params[key] = value;

        // Llamar al thunk con los parámetros
        dispatch(onGetChecksThunk(params));
    };

    return (
        <>
            {loading_hdop && loading_fatigue && loading_checks && loading_frentes ? (
                <LoadingContent />
            ) : (
                <Stack gap={3}>
                    <InformationContainer color='#000000' background='#FB7E50' description="Esta Checklist se reinicia al final del turno y se comparte entre todos los usuarios que sean encargados de UCO." />
                    <Card justifyContent='flex-start' >
                        <ListChecked size={18} />
                        <Typography className='cds--type-heading-compact-01'>
                            LISTA DE TAREAS Y RECOMENDACIONES
                        </Typography>
                    </Card>
                    <Card flex={1} flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                        <Typography className='cds--type-body-01'>
                            <View size={18} style={{ marginRight: '8px' }} /> Revisar activamente las notificaciones
                        </Typography>
                        <Typography className="cds--type-label-01">
                            Puede revisar esto en{' '}
                            <Link
                                to={routes.usersInitial}
                                style={{
                                    color: '#FFFFFF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Notificaciones
                            </Link>.
                        </Typography>
                    </Card>
                    <Card
                        flexDirection="column"
                        justifyContent="flex-start"
                        padding={spacing05}
                        style={{ width: '100%' }}
                    >
                        <div style={{ width: '100%', paddingBottom: '10px' }}>
                            <Checkbox
                                id="checkbox_1"
                                labelText="Validar Frentes y geocercas de frentes"
                                checked={isChecked}
                                onChange={(_, { checked }) => handleCheckboxChange(setIsChecked, checked, 'check_frentes')}
                                width="100%"
                            />
                            <Typography className="cds--type-label-01">
                                Puede revisar esto en{' '}
                                <Link
                                    to={routes.fronts}
                                    style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Mapa de frentes
                                </Link>.
                            </Typography>
                        </div>
                        <DataTable width="100%" rows={rows} headers={headers}>
                            {({ rows, headers, getTableProps, getHeaderProps, getRowProps }) => (
                                <Table
                                    {...getTableProps()}
                                    style={{
                                        width: '100%',
                                        tableLayout: 'fixed',
                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            {headers.map((header) => {
                                                const { key, ...headerProps } = getHeaderProps({ header }); // Extract key separately
                                                return (
                                                    <TableHeader key={key} {...headerProps} style={{ textAlign: 'left' }}>
                                                        {header.header}
                                                    </TableHeader>
                                                );
                                            })}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => (
                                            <TableRow {...getRowProps({ row })} key={row.id}>
                                                {row.cells.map((cell) => (
                                                    <TableCell key={cell.id} style={{ wordWrap: 'break-word' }}>
                                                        {cell.value}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            )}
                        </DataTable>
                        <div style={{ width: '100%' }}>
                            <InformationContainer background='#525252'
                                description={
                                    <>
                                        En caso de haber un frente que ya no está activo o un frente ausente, enviar un correo a{' '}
                                        <a
                                            href="mailto:carlos.olaechea@terrestra.tech"
                                            style={{
                                                textDecoration: 'underline',
                                                color: '#FFFFFF',
                                            }}
                                        >
                                            carlos.olaechea@terrestra.tech
                                        </a>{' '}
                                        especificando los cambios necesarios.
                                    </>
                                }
                            />
                        </div>
                    </Card>
                    <Card justifyContent='flex-start' padding={spacing05} flexDirection="column" style={{ width: '100%' }} >
                        <div style={{ width: '100%', paddingBottom: '10px' }}>
                            <Checkbox
                                id="checkbox_2"
                                labelText="Monitorear la desviación de la señal gps de la flota a través del HDOP"
                                checked={isChecked_2}
                                onChange={(_, { checked }) => handleCheckboxChange(setIsChecked_2, checked, 'check_hdop')}
                                width="100%"
                            />
                            <Typography className="cds--type-label-01">
                                Puede revisar esto con mas detalle en{' '}
                                <Link
                                    to={routes.monitoringmap}
                                    style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Mapa de flota
                                </Link>.
                            </Typography>
                        </div>
                        <CarbonTableComponent
                            headers={[
                                "Patente",
                                "Tipo de equipo",
                                "HDOP"
                            ]}
                            rows={
                                tableRows.map((row) => [
                                    row.name,
                                    row.status, // Corresponde a la primera columna
                                    row.example   // Corresponde a la segunda columna
                                ])
                            }
                        />
                        <div style={{ width: '100%' }}>
                            <InformationContainer background='#525252' description="La tabla muestra el HDOP de los equipos con HDOP superior a 2, un valor > 2 representa un problema con la antena o el dispositivo de telemetría." />
                        </div>
                    </Card>
                    <Card justifyContent='flex-start' padding={spacing05} flexDirection="column" style={{ width: '100%' }} >
                        <div style={{ width: '100%', paddingBottom: '10px' }}>
                            <Checkbox
                                id="checkbox_6"
                                labelText="Monitorear equipos con ausencia de advertencias y alertas de fatiga durante su último turno"
                                checked={isChecked_6}
                                onChange={(_, { checked }) => handleCheckboxChange(setIsChecked_6, checked, 'check_fatiga')}
                                width="100%"
                            />
                            <Typography className="cds--type-label-01">
                                Puede revisar esto con mas detalle en{' '}
                                <Link
                                    to={routes.securityCamera}
                                    style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Estado Cámara Fatiga
                                </Link>.
                            </Typography>
                        </div>
                        <CarbonTableComponent
                            headers={[
                                "Device_id",
                                "Patente",
                                "Tipo de equipo"
                            ]}
                            rows={
                                tableRows_2.map((row) => [
                                    row.name,
                                    row.status, // Corresponde a la primera columna
                                    row.example   // Corresponde a la segunda columna
                                ])
                            }
                        />
                        <div style={{ width: '100%' }}>
                            <InformationContainer background='#525252' description="La tabla muestra equipos que han estado operativos y que no han enviado advertencias o alertas durante su último turno." />
                        </div>
                    </Card>
                    <Card justifyContent='flex-start' padding={spacing05} flexDirection="column" style={{ width: '100%' }} >
                        <div style={{ width: '100%' }}>
                            <Checkbox
                                id="checkbox_3"
                                labelText="Monitorear el estado de conexión de los equipos."
                                checked={isChecked_3}
                                onChange={(_, { checked }) => handleCheckboxChange(setIsChecked_3, checked, 'check_conexion')}
                                width="100%"
                            />
                            <Typography className="cds--type-label-01">
                                Puede revisar esto en{' '}
                                <Link
                                    to={routes.monitoringmap}
                                    style={{
                                        color: '#FFFFFF', // Color del enlace
                                        fontWeight: 'bold' // Opcional: enfatizar el enlace
                                    }}
                                >
                                    Mapa de flota
                                </Link>.
                            </Typography>
                        </div>
                    </Card>
                    <Card justifyContent='flex-start' padding={spacing05} flexDirection="column" style={{ width: '100%' }} >
                        <div style={{ width: '100%' }}>
                            <Checkbox
                                id="checkbox_4"
                                labelText="Revisar Vigencia de las licencias."
                                checked={isChecked_4}
                                onChange={(_, { checked }) => handleCheckboxChange(setIsChecked_4, checked, 'check_vigencia_licencias')}
                                width="100%"
                            />
                            <Typography className="cds--type-label-01">
                                Puede revisar esto en{' '}
                                <Link
                                    to={routes.recordsDriver}
                                    style={{
                                        color: '#FFFFFF', // Color del enlace
                                        fontWeight: 'bold' // Opcional: enfatizar el enlace
                                    }}
                                >
                                    Conductores
                                </Link>.
                            </Typography>
                        </div>
                    </Card>
                    <Card justifyContent='flex-start' padding={spacing05} flexDirection="column" style={{ width: '100%' }} >
                        <div style={{ width: '100%' }}>
                            <Checkbox
                                id="checkbox_5"
                                labelText="Subir Fotos de Licencias nuevas."
                                checked={isChecked_5}
                                onChange={(_, { checked }) => handleCheckboxChange(setIsChecked_5, checked, 'check_nuevas_licencias')}
                                width="100%"
                            />
                            <Typography className="cds--type-label-01">
                                Puede revisar esto en{' '}
                                <Link
                                    to={routes.recordsDriver}
                                    style={{
                                        color: '#FFFFFF', // Color del enlace
                                        fontWeight: 'bold' // Opcional: enfatizar el enlace
                                    }}
                                >
                                    Conductores
                                </Link>.
                            </Typography>
                        </div>
                    </Card>
                </Stack>
            )}
        </>
    )
}

export default RecomendationsContainer